import * as React from "react";
import styled, { css } from "styled-components";
import {
  isTypeKeyword,
  isTypeRelativeWithStartOnly,
  isTypeRelativeWithEnd,
  isNoTimeRangeOverride
} from "views/typeGuards/timeRange";
import { readableRange } from "views/logic/queries/TimeRangeToString";
import assertUnreachable from "logic/assertUnreachable";
export const EMPTY_RANGE = "----/--/-- --:--:--.---";
export const EMPTY_OUTPUT = { from: EMPTY_RANGE, until: EMPTY_RANGE };
const TimeRangeWrapper = styled.div(
  ({ theme }) => css`
    width: 100%;
    padding: 3px 13px;
    display: flex;
    justify-content: space-around;
    background-color: ${theme.colors.table.row.backgroundStriped};
    align-items: center;

    > span {
      flex: 1;
    }
  `
);
export const range = (timerange) => {
  let from = EMPTY_RANGE;
  let to = EMPTY_RANGE;
  if (!(timerange == null ? void 0 : timerange.type)) {
    return EMPTY_OUTPUT;
  }
  const { type } = timerange;
  switch (type) {
    case "relative":
      if (isTypeRelativeWithStartOnly(timerange)) {
        from = readableRange(timerange, "range");
      }
      if (isTypeRelativeWithEnd(timerange)) {
        from = readableRange(timerange, "from");
      }
      to = readableRange(timerange, "to", "Now");
      return {
        from,
        until: to
      };
    case "absolute":
      return { from: timerange.from, until: timerange.to };
    default:
      return assertUnreachable(type, "Invalid time range type");
  }
};
const TimeRange = ({ timerange }) => {
  if (isTypeKeyword(timerange)) {
    return /* @__PURE__ */ React.createElement("span", null, "Keyword: ", /* @__PURE__ */ React.createElement("b", null, timerange.keyword));
  }
  const { from, until } = range(timerange);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { "data-testid": "from" }, "From: ", /* @__PURE__ */ React.createElement("b", null, from)), /* @__PURE__ */ React.createElement("span", { "data-testid": "to" }, "Until: ", /* @__PURE__ */ React.createElement("b", null, until)));
};
const TimeRangeDisplay = ({ timerange, toggleDropdownShow = void 0 }) => /* @__PURE__ */ React.createElement(
  TimeRangeWrapper,
  {
    "aria-label": "Search Time Range, Opens Time Range Selector On Click",
    role: "button",
    onClick: toggleDropdownShow
  },
  isNoTimeRangeOverride(timerange) ? /* @__PURE__ */ React.createElement("span", null, "No Override") : /* @__PURE__ */ React.createElement(TimeRange, { timerange })
);
export default TimeRangeDisplay;
